export default {
    'en-us': {
        visitorsPortraitVA: 'Visitors Portrait VA',
        visitorsPortrait: 'Visitors Portrait',
        zonePleaseSelect: 'Entirezone',
        name: 'Name',
        identity: 'Identity',
        gender: 'Gender',
        age: 'Age',
        expression: 'Expression',
        stayLength: 'Retention Time',
        enterTime: 'Enter Time',
        exitTime: 'Departure Time',
        title: 'Visit Record',
        dateRangeError: `The selected time range cannot exceed {DateRange} days`,
        indicators: 'Indicator',
        unique: 'Unique Visitors',
        visitations: 'Total Captured Portraits',
        visitors: 'Visitors Insights',
        ageTitle: 'Age Proportion',
        ST_OLD: 'Elders',
        ST_CHILD: 'Children',
        ST_ADULT: 'Adults',
        uniqueFrequency: 'Unique',
        amount: 'Total',
        genderTitle: 'Gender Proportion',
        expressionTitle: 'Expression Proportion',
        female: 'Female',
        male: 'Male',
        identityTitle: 'Identity Proportion',
        realName: 'Real-name',
        anonymous: 'Anonymous',
        visitAgeTitle: 'Trend of Visitors (Age）',
        visitGenderTitle: 'Trend of Visitors (Gender)',
        visitExpressionTitle: 'Trend of Visitors (Expression)',
        stayTitle: 'Visitor Retention Time',
        stayIdentity: 'Identity',
        stayGender: 'Gender',
        stayAge: 'Age',
        stOld: 'Elders',
        stChild: 'Children',
        stAdult: 'Adults',
        total: 'Total {msg} Items',
        day: 'Day',
        hour: 'Hour',
        HAPPY: 'Happy',
        UNHAPPY: 'Unhappy',
        CALM: 'Calm',
        returnedVistors: 'Returned Vistors',
        clusterTypeYear: 'The number of visitors who have recorded multiple visits in the past year',
        clusterTypeDays: 'The number of visitors who have recorded multiple visits in the past 30 days',
        customersType: 'Type',
        numberOfVisits: 'Number of Visits',
        visitorCountYear: 'The number of visits by visitors in the last 365 days',
        visitorCountDays: 'The number of visits by visitors in the last 30 days',
        numberOfVisitsTitle: 'Number of Visits Proportion',
        trendOfReturnedCustomersTitle: 'Trend of Returned Customers',
        once: 'Once',
        twice: '2 times',
        threeTimes: '3 times',
        fourTimes: '4 times',
        moreThanFourTimes: 'More than 4 times',
        returnedCustomers: 'Returned Customers',
    },
    zh: {
        visitorsPortraitVA: '用户画像VA',
        visitorsPortrait: '用户画像',
        zonePleaseSelect: '选择区域',
        name: '姓名',
        identity: '身份',
        gender: '性别',
        age: '年龄',
        expression: '表情',
        stayLength: '停留时间',
        enterTime: '进入时间',
        exitTime: '离开时间',
        title: '访问记录',
        dateRangeError: `选择时间范围不能超过{DateRange}天`,
        indicators: '关键指标',
        unique: '独立访客',
        visitations: '人像捕捉',
        visitors: '游客分布',
        ageTitle: '年龄分布',
        ST_OLD: '老人',
        ST_CHILD: '小孩',
        ST_ADULT: '成年人',
        uniqueFrequency: '按独立访客',
        amount: '按人像捕捉',
        genderTitle: '性别分布',
        expressionTitle: '表情分布',
        female: '女性',
        male: '男性',
        identityTitle: '身份分布',
        realName: '实名',
        anonymous: '非实名',
        visitAgeTitle: '访问趋势（按年龄）',
        visitGenderTitle: '访问趋势（按性别）',
        visitExpressionTitle: '访问趋势（按表情）',
        stayIdentity: '按身份',
        stayGender: '按性别',
        stayAge: '按年龄',
        stayTitle: '停留时长',
        stOld: '老人',
        stChild: '小孩',
        stAdult: '成年人',
        total: '总共 {msg} 条',
        day: '天',
        hour: '小时',
        HAPPY: '高兴',
        UNHAPPY: '不高兴',
        CALM: '平静',
        returnedVistors: '复访访客',
        clusterTypeYear: '近一年内有过重复访问记录的访客量',
        clusterTypeDays: '近30天内有过重复访问记录的访客量',
        customersType: '类型',
        numberOfVisits: '访问次数',
        visitorCountYear: '近365天内该访客的访问次数',
        visitorCountDays: '近30天内该访客的访问次数',
        numberOfVisitsTitle: '访问次数分布',
        trendOfReturnedCustomersTitle: '复访访客访问趋势',
        once: '1次',
        twice: '2次',
        threeTimes: '3次',
        fourTimes: '4次',
        moreThanFourTimes: '大于4次',
        returnedCustomers: '复访访客',
    }
};
